import { EXTENSION_LINK } from "app/pages/sales-intelligence/constants/common";
import {
    ACCOUNT_OVERVIEW_HOME,
    ENRICHMENT_PAGE_ROUTE,
    FIND_LEADS_SEARCH_ROUTE,
    INTENT_SIGNALS_MANAGEMENT_PAGE_ROUTE,
    MANAGEMENT_ROUTE,
    MY_LISTS_PAGE_ROUTE,
} from "app/pages/sales-intelligence/constants/routes";
import { profileModalIsOpenedSetAction } from "app/pages/sales-intelligence/modules/company-analysis/store/contacts/action-creators";
import { OnboardingGoalQuestionType } from "app/pages/sales-intelligence/sub-modules/onboarding/types/enums";
import { isSignalsManagementOpenAction } from "app/pages/sales-intelligence/sub-modules/signals/store/action-creators";
import { proNavigator } from "single-spa/react-app/ProNavigator";
import type { ThunkDispatchCommon } from "single-spa/store/types";

// for wizard and hub
export function redirectUserByGoal(goal: OnboardingGoalQuestionType): void {
    switch (goal) {
        case OnboardingGoalQuestionType.FindNewProspects:
            proNavigator.go(FIND_LEADS_SEARCH_ROUTE, { findNewProspects: true });
            break;
        case OnboardingGoalQuestionType.EnrichCsvWithCompanies:
            proNavigator.go(ENRICHMENT_PAGE_ROUTE); // no page yet (Enrich a list of companies)
            break;
        case OnboardingGoalQuestionType.UploadListOfCompanies:
            proNavigator.go(MY_LISTS_PAGE_ROUTE, { openAddList: true });
            break;
        case OnboardingGoalQuestionType.ConnectMyCrm:
            proNavigator.go(MANAGEMENT_ROUTE, {
                isScrollToIntegrationSection: true,
            });
            break;
        case OnboardingGoalQuestionType.ResearchSpecificCompany:
            proNavigator.go(ACCOUNT_OVERVIEW_HOME);
            break;
    }
}

// for hub
export function redirectUserByTask(taskType: OnboardingGoalQuestionType, dispatch: ThunkDispatchCommon): void {
    switch (taskType) {
        case OnboardingGoalQuestionType.SyncMyCrm:
        case OnboardingGoalQuestionType.UploadSuppressionList:
            proNavigator.go(MANAGEMENT_ROUTE, {
                isScrollToIntegrationSection: true,
            });
            break;
        case OnboardingGoalQuestionType.SetUpAlerts:
            dispatch(isSignalsManagementOpenAction(true));
            break;
        case OnboardingGoalQuestionType.CreateContactProfile:
            dispatch(profileModalIsOpenedSetAction(true));
            break;

        case OnboardingGoalQuestionType.SetUpIntentAlerts:
            proNavigator.go(INTENT_SIGNALS_MANAGEMENT_PAGE_ROUTE);
            break;
        case OnboardingGoalQuestionType.DownloadChromeExtension:
            window.open(EXTENSION_LINK, "_blank");
            break;
        default:
            redirectUserByGoal(taskType);
    }
}
